import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { LabelingState } from '@/stores/slices/Labeling/types'
import { addClass, getUserClasses, updateClassOrder } from '@/stores/slices/Labeling/thunks/class'

export const classExtraReducers = (builder: ActionReducerMapBuilder<LabelingState>) => {
  builder.addCase(addClass.pending, (state) => { state.isAddingClass = true })
  builder.addCase(addClass.fulfilled, (state) => { state.isAddingClass = false })
  builder.addCase(addClass.rejected, (state) => { state.isAddingClass = false })

  builder.addCase(getUserClasses.fulfilled, (state, action) => {
    state.classes = action.payload
  })
  builder.addCase(updateClassOrder.fulfilled, (state, action) => {
    state.classes = action.payload
  })
}
